export * from './delete-vermerk.command.module';
export * from './component';
export * from './service';